export const permissions = {
  inbox: "Access the Inbox",
  inboxWrite: "Can reply in the Inbox",
  calendar: "Access the Calendar",
  calendarWrite: "Can create/edit events in the Calendar",
  overview: "Access the Dashboard",
  analytics: "Access the Analytics",
  networkPermissions: "Manage Group permissions",
  venuePermissions: "Manage Venue permissions",
  addUsers: "Invite users to the Group/Venues",
  venueProfile: "Edit Venue profiles",
};
export const networkPermissions = (({ networkPermissions, addUsers }) => ({
  networkPermissions,
  addUsers,
}))(permissions);
export const venuePermissions = (({
  inbox,
  inboxWrite,
  calendar,
  calendarWrite,
  overview,
  analytics,
  venueProfile,
  venuePermissions,
}) => ({
  inbox,
  inboxWrite,
  calendar,
  calendarWrite,
  overview,
  analytics,
  venueProfile,
  venuePermissions,
}))(permissions);
